// extracted by mini-css-extract-plugin
export var bodySections = "_br-8";
export var gray = "_br-7";
export var green = "_br-4";
export var iconContainer = "_br-9";
export var iconWidgetContainer = "_br-1";
export var phoneIcon = "_br-2";
export var red = "_br-5";
export var statusDot = "_br-3";
export var widgetContainer = "_br-0";
export var yellow = "_br-6";